<section
  class="Receipt"
  [ngClass]="{
    'Receipt--Large':
      (config?.size && config?.size === sizes.large) || !config?.size,
  }"
>
  @for (row of data; track row) {
    <div class="Receipt__Row">
      @if (config?.isNameDisplayed) {
        <p class="Receipt__Text">{{ row.name }}</p>
      }
      @if (config?.isGroupNameDisplayed) {
        <p class="Receipt__Text">{{ config?.groupLabel }} {{ row.group }}</p>
      }
      <div class="Receipt__Divider"></div>
      @if (config?.isSubtotalDisplayed) {
        <p class="Receipt__Cost">
          {{ row.cost | formatCurrency }}
        </p>
      }
    </div>
  }

  @if (config?.isTotalDisplayed) {
    <div class="Receipt__Row">
      <p class="Receipt__Text">
        Total
        @if (config?.billDescription) {
          <span>({{ config?.billDescription }})</span>
        }
      </p>
      <div class="Receipt__Divider"></div>
      <p class="Receipt__Cost">{{ total }}</p>
    </div>
  }

  @if (billDetails$ | async; as billDetails) {
    @if (billDetails.lastPaidDate && billDetails.lastPaidAmount) {
      <div class="Receipt__LastPayment">
        <div class="Receipt__BillDetailsLastPaymentValue">
          <div class="Receipt__Row">
            <p class="Receipt__Text">Last Payment</p>
            <p class="Receipt__Text">Amount Applied</p>
            <p class="Receipt__Text">{{ billDetails.lastPaidDate }}</p>
            <div class="Receipt__Divider"></div>
            <description class="Receipt__Cost"
              >({{ billDetails.lastPaidAmount | formatCurrency }})</description
            >
          </div>
        </div>
      </div>
    }
    <div class="Receipt__LastPaymentSummary">
      @for (data of billDetails.summary; track data) {
        <div class="Receipt__LastPaymentSummaryWrapper">
          <caption-label class="Receipt__LastPaymentSummaryLabel">
            {{ data?.label }}
          </caption-label>
          <description class="Receipt__LastPaymentSummaryValue">{{
            data?.value
          }}</description>
        </div>
      }
    </div>
  }
</section>
